var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"scrollable":"","max-width":"600"},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('v-card',[_c('v-img',{attrs:{"src":_vm.photoUrl,"alt":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }